import React from 'react'
import { FormGroup, Input, Label } from 'reactstrap'
import { PropTypes } from 'prop-types'

export function PrettySwitch (props) {
  return (
    <React.Fragment>
      {props.labelText &&
        <label className='mt-2 control-label font-weight-bold'>{props.labelText}</label>
      }
      {
        !props.inline && <br/>
      }
      {/* <div className='pretty p-switch top-10'> */}
      <div className={`pretty p-switch  ${props.inline ? 'top-10 ml-1' : ''}`}>
        <FormGroup className='mb-0'>

          <Input
            id={props.id}
            type='checkbox'
            aria-label = {props.name}
            disabled={props.disabled}
            checked={props.checked}
            name={props.name}
            value={props.value}
            className={`mr-1 ${props.className}`}
            onChange={props.changeHandler} />
          <div className='state p-success'>
            <Label>
              {props.value ? 'Yes' : 'No'}
            </Label>
          </div>
        </FormGroup>
      </div>
    </React.Fragment>
  )
}

PrettySwitch.defaultProps = {
  className: '',
  changeHandler: null,
  labelText: '',
  name: '',
  inline: false,
  disabled: false
}

PrettySwitch.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  labelText: PropTypes.string,
  changeHandler: PropTypes.func,
  checked: PropTypes.bool,
  value: PropTypes.bool,
  inline: PropTypes.bool,
  disabled: PropTypes.bool
}
